import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";

interface PasswordUnmaskProps {

}

@Dce("PasswordUnmask")
export default class PasswordUnmask extends DceComponent<PasswordUnmaskProps> {

    private input: JQuery<HTMLElement>;

    private toggle: JQuery<HTMLElement>;

    constructor(elem: DceHTMLElement, props: PasswordUnmaskProps) {
        super(elem, props);
        this.input = $(elem);
        this.toggle = $('<span class="unmask-button"/>');

        this.addToggle();

        this.toggle.on('mouseenter', (e) => {
            this.input.attr('type', 'text');
        });

        this.toggle.on('mouseleave', (e) => {
            this.input.attr('type', 'password');
        });
    }

    private addToggle(){
        console.log("ZZZ", this.input);

        let height = parseInt(this.input.css('height'));

        if(height == 0){
            setTimeout(() => {
                this.addToggle();
            }, 200);
            return;
        }

        var iconHeight = height;
        if(iconHeight > 24){
            iconHeight = 24;
        }

        if(height <= 24){
            iconHeight = 0.8 * height;
        }

        this.toggle.css({
            'font-size': iconHeight + 'px',
            'line-height': height + 'px',
            'height': height + 'px',
            'margin-left': '-' + (iconHeight+6) + 'px'
        });

        this.input.after(this.toggle);

    }

}
